import { MouseEvent } from 'react';
import { IconButton, IconMoreVert } from 'cdk-radial';
import * as Styles from '../components/Cards/styles';
import toTestId from '../utils/toTestId';
import { useTranslation } from 'react-i18next';
import { withTooltip, THEMES } from 'cdk-radial';

interface Props {
  isIconRequired?: boolean;
  isEnabled: boolean;
  description?: string;
  name: string;
  iconText?: string;
  onOpenClick: (e: MouseEvent) => void;
  iconColor: string;
  menuRef: any;
  isRestricted?: boolean;
  restrictedTooltipMsg?: string;
}

export interface CardMenu {
  key: string;
  label: string;
  icon?: any;
}

const ComponentToRender = (props: any) => {
  const { t } = useTranslation();
  return (
    <Styles.WarningMessage {...props}>
      <Styles.WarningIcon height={18} width={18} dataTestId="restricted-warning"/>
      {t('baseCard.restrictedWarning')}
    </Styles.WarningMessage>
  );
};

export const RestrictedTooltip = ({message}: any) => {
  const RestrictedWarningIcon = withTooltip(ComponentToRender, 
    {
      id: `restricted-tooltip-icon`,
      text: message, 
      theme: THEMES.LIGHT,
      styles: { zIndex: 1002, display: window.innerWidth < 501 && 'none' }
    }
  );
  return <RestrictedWarningIcon></RestrictedWarningIcon>;
}

export default function Card({
  isIconRequired = true,
  isEnabled,
  description,
  name,
  iconText,
  iconColor,
  onOpenClick,
  menuRef,
  isRestricted,
  restrictedTooltipMsg,
}: Props) {

  const onMoreClick = (event: MouseEvent) => {
    event.stopPropagation();
    return false;
  }

  const onCardClick = (e: MouseEvent) => {
    // Don't trigger card click if clicking the menu button
    const target = e.target as HTMLElement;
    if (target.closest('[data-id="icon-card-more"]')) {
      return;
    }
    onOpenClick(e);
  }

  return (
    <>
      <Styles.Card
        data-testid={`card-${toTestId(name)}`}
        onClick={(e) => !isRestricted && isEnabled && onCardClick(e)}
        onKeyDown={(e: any) => {
          if ((e.key === 'Enter' || e.key === ' ') && !isRestricted && isEnabled) {
            e.preventDefault();
            onCardClick(e);
          }
        }}
      >
        <div>
          <Styles.CardHeader>
            {isIconRequired && (
              <Styles.ProductIcon iconColor={iconColor} data-testid="app-icon">
                {iconText || ''}
              </Styles.ProductIcon>
            )}
            <Styles.CardTitle>
              {name}
              {isRestricted && ( 
                <RestrictedTooltip message={restrictedTooltipMsg}></RestrictedTooltip>
              )}
            </Styles.CardTitle>
          </Styles.CardHeader>
          {/* REMOVED: Description should only show in Learn More dialog, not on the card */}
        </div>
        <Styles.IconWrap data-id='icon-card-more'>
          <IconButton 
            ref={menuRef}
            dataTestId="bc-more-btn"
            icon={<IconMoreVert />}
            onClick={onMoreClick}
            isDisabled={isRestricted}
            text=""
          />
        </Styles.IconWrap>
      </Styles.Card>
    </>
  );
}
